
class FunReportStandart {
    formatToRepKegiatan(item, itemsFDivision, itemsFPegawai, itemsFCvpt){
        const newItem ={}
        newItem.kode1 = `*${item.kode1}`
        newItem.description = item.description
        newItem.tahun = item.tahun
        newItem.fdivision = itemsFDivision.filter(x =>x.id===item.fdivision).description
        newItem.namaPekerjaan = item.namaPekerjaan
        newItem.gantiNamaPaket = item.gantiNamaPaket
        newItem.nilaiPagu = item.nilaiPagu
        newItem.lat =item.lat
        newItem.lon =item.lon

        newItem.cvptBean = itemsFCvpt.filter(x =>x.id===item.cvptBean).description
        newItem.nomorKontrak = item.nomorKontrak
        newItem.tglKontrak = item.tglKontrak
        newItem.nilaiKontrak = item.nilaiKontrak

        newItem.kpaBean = itemsFPegawai.filter(x =>x.id===item.kpaBean).description
        newItem.pptkBean = itemsFPegawai.filter(x =>x.id===item.pptkBean).description
        newItem.pengawasBean = itemsFPegawai.filter(x =>x.id===item.pengawasBean).description

        newItem.ketuaBean = itemsFPegawai.filter(x =>x.id===item.ketuaBean).description
        newItem.sekretarisBean = itemsFPegawai.filter(x =>x.id===item.sekretarisBean).description
        newItem.anggota1Bean = itemsFPegawai.filter(x =>x.id===item.anggota1Bean).description
        newItem.anggota2Bean = itemsFPegawai.filter(x =>x.id===item.anggota2Bean).description

        newItem.nomorAdendum = item.nomorAdendum
        newItem.tglAdendum = item.tglAdendum
        newItem.nomorKemajuan = item.nomorKemajuan
        newItem.tglKemajuan = item.tglKemajuan
        newItem.nomorPenyerahan = item.nomorPenyerahan
        newItem.tglPenyerahan = item.tglPenyerahan
        newItem.nomorFho = item.nomorFho
        newItem.tglFho = item.tglFho
        newItem.nomorPho = item.nomorPho
        newItem.tglPho = item.tglPho
        newItem.termin1Cair = item.termin1Cair
        newItem.termin2Cair = item.termin2Cair

        return newItem
    }
    getHeaderRepKegiatan = {
        'Nomor': 'Kode1',
        'Kegiatan': 'description',
        'Tahun': 'tahun',
        'Bidang': 'fdivision',
        'Nama Pekerjaan': 'namaPekerjaan',
        'Ganti nama Paket': 'gantiNamaPaket',
        'Nilai Pagu': 'nilaiPagu',
        'Latitude': 'lat',
        'Longitude': 'lon',

        'Kontraktor/Konsultan': 'cvptBean',
        'Nomor Kontrak': 'nomorKontrak',
        'Tanggal Kontrak': 'tglKontrak',
        'Nilai Kontrak': 'nilaiKontrak',

        'KPA': 'kpaBean',
        'PPTK': 'pptkBean',
        'PENGAWAS': 'pengawasBean',

        'Ketua': 'ketuaBean',
        'Sekretaris': 'sekretarisBean',
        'Anggota-1': 'anggota1Bean',
        'Anggota-2': 'anggota2Bean',

        'Nomor Adendum': 'nomorAdendum',
        'Tanggal Adendum': 'tglAdendum',
        'Nomor Kemajuan': 'nomorKemajuan',
        'Tanggal Kemajuan': 'tglKemajuan',
        'Nomor Penyerahan': 'nomorPenyerahan',
        'Tanggal Penyerahan': 'tglPenyerahan',
        'Nomor FHO': 'nomorFho',
        'Tanggal FHO': 'tglFho',
        'Nomor PHO': 'nomorPho',
        'Tanggal PHO': 'tglPho',
        'Termin ke-1': 'termin1Cair',
        'Termin ke02': 'termin2Cair',
    }

}

export default new FunReportStandart()